// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7KCUI","bannerImage":"Banner_bannerImage__Q19x8","hero":"Banner_hero__-k1oK"};